import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export const RecurringInvoicesTableEmptyRowInfo = (): ReactNode => {
  const { t } = useTranslation()

  return t('table.empty_message')
}
